import { STRING_getInstance2ou4lro9xn2qn as STRING_getInstance } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialKinds.mjs';
import { PrimitiveSerialDescriptor3egfp53lutxj2 as PrimitiveSerialDescriptor } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialDescriptors.mjs';
import {
  Companion_getInstance2vzevs5m6d283 as Companion_getInstance,
  LocalDateTime3vqv9moe7clf4 as LocalDateTime,
} from '../LocalDateTime.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var LocalDateTimeIso8601SerializerClass;
function LocalDateTimeIso8601Serializer() {
  if (LocalDateTimeIso8601SerializerClass === VOID) {
    class $ {
      constructor() {
        LocalDateTimeIso8601Serializer_instance = this;
        this.n25_1 = PrimitiveSerialDescriptor('kotlinx.datetime.LocalDateTime', STRING_getInstance());
      }
      az() {
        return this.n25_1;
      }
      pz(decoder) {
        return Companion_getInstance().q25(decoder.h13());
      }
      r25(encoder, value) {
        encoder.p14(value.toString());
      }
      oz(encoder, value) {
        return this.r25(encoder, value instanceof LocalDateTime() ? value : THROW_CCE());
      }
    }
    initMetadataForObject($, 'LocalDateTimeIso8601Serializer', VOID, VOID, [KSerializer()]);
    LocalDateTimeIso8601SerializerClass = $;
  }
  return LocalDateTimeIso8601SerializerClass;
}
var LocalDateTimeIso8601Serializer_instance;
function LocalDateTimeIso8601Serializer_getInstance() {
  if (LocalDateTimeIso8601Serializer_instance === VOID)
    new (LocalDateTimeIso8601Serializer())();
  return LocalDateTimeIso8601Serializer_instance;
}
//region block: exports
export {
  LocalDateTimeIso8601Serializer_getInstance as LocalDateTimeIso8601Serializer_getInstance2em1n1hwy5urt,
};
//endregion

//# sourceMappingURL=LocalDateTimeSerializers.mjs.map
